
import { defineComponent, ref } from "vue";

interface Filter {
  name: string;
}

export default defineComponent({
  name: "account-filter",
  components: {},
  emits: ["search"],
  setup() {
    const data = ref<Filter>({
      name: "",
    });
    const defaultVal: Filter = {
      name: "",
    };

    return {
      defaultVal,
      data,
    };
  },
  methods: {
    handleFindPage() {
      this.$emit("search", this.data.name);
    },
    handleReset() {
      if (this.defaultVal != this.data) {
        this.data = Object.assign({}, this.defaultVal);
        this.$emit("search", this.data.name);
      }
    },
  },
  mounted() {
    this.handleReset();
  },
});
